import { useMutation } from '@tanstack/react-query-v4'
import { useApi } from '@api/useApi.hook'
import { QueryKey } from '@api'
import { appConfig } from '@config'
import { queryClient } from '@providers/react-query'
import type { AddFavoriteItemInput, FavoriteItemDto } from './favorites.types'

export const useAddFavoriteItem = () => {
  const { post } = useApi()

  return useMutation({
    mutationFn: async (input: AddFavoriteItemInput): Promise<FavoriteItemDto> => {
      return post<FavoriteItemDto>(appConfig.endpoints.v1.favorites.items, {
        disableAutoSnakeCase: true,
      })({
        contractAddress: input.contractAddress,
        nftId: input.nftId,
      })
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Favorites] })
      await queryClient.invalidateQueries({ queryKey: [QueryKey.FavoritesExists] })
    },
  })
}
